module.exports = __webpack_public_path__ + "img/photosession_1_9.bc47de7c.jpg";